export default __webpack_public_path__ + "static/media/may-2021-us.06d55759.csv";